import axios from 'axios';

import authHeader from './authHeader';
import { Config } from '@/config';

class ContractService {
  async get() {
    try {
      const response = await axios.get(`${Config.HOST.URL}${Config.API_ROUTES.CONTRACTS.GET_ALL}`, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }
}

export default new ContractService();
